import { render, staticRenderFns } from "./PasswordScore.vue?vue&type=template&id=2989d3a5&scoped=true&"
import script from "./PasswordScore.vue?vue&type=script&lang=js&"
export * from "./PasswordScore.vue?vue&type=script&lang=js&"
import style0 from "./PasswordScore.vue?vue&type=style&index=0&id=2989d3a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2989d3a5",
  null
  
)

export default component.exports